import script from "./VerificationCodeInput.vue?vue&type=script&setup=true&lang=js"
export * from "./VerificationCodeInput.vue?vue&type=script&setup=true&lang=js"

import "./VerificationCodeInput.vue?vue&type=style&index=0&id=411521ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-411521ea"]])

export default __exports__